import { FC } from "react";
import { IconProps } from "./types";

export const SocialXFilled: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path d="M14.733 17.02h1.52L9.259 7.014h-1.52l6.994 10.005z" fill={fill} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.241-17.73-4.175 4.852 4.54 6.608h-3.338l-3.058-4.45-3.827 4.45h-.99l4.378-5.088L6.394 6.27h3.338l2.895 4.213 3.625-4.213h.99z"
      fill={fill}
    />
  </svg>
);
